/* global G */

/**
 * Alters the configuration of the action's search field. It does so
 * by copying all properties from `config` to the action's ui search
 * configuration object.
 *
 * @param {Object} config
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const setSearchFieldConfig = config => obj => async (...args) => {
  const action = obj[G.STATE][G.ACTION]
  const ui = action[G.UI]

  ui?.search && Object.keys(config).forEach((key) => {
    ui.search[key] = config[key]
  })

  return args
}

export default setSearchFieldConfig
